module.exports = __webpack_public_path__ + "img/5-7.e67bd00b.png";